/**
 * @flow
 * @relayHash 86d2a6a678c421f7a2d6217c094e52c1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateWuploadInput = {
  clientMutationId?: ?string,
  workspace_id: string,
  name: string,
  mimetype: string,
  source: string,
  url: string,
  size: number,
  handle: string,
};
export type NewDocument_CreateWuploadMutationVariables = {|
  input: CreateWuploadInput
|};
export type NewDocument_CreateWuploadMutationResponse = {|
  +createWupload: ?{|
    +workspace: ?{|
      +wuploads: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +mimetype: ?string,
            +name: ?string,
            +url: ?string,
          |}
        |}>
      |}
    |},
    +new_wupload_edge: ?{|
      +node: ?{|
        +id: string,
        +mimetype: ?string,
        +name: ?string,
        +url: ?string,
      |}
    |},
  |}
|};
export type NewDocument_CreateWuploadMutation = {|
  variables: NewDocument_CreateWuploadMutationVariables,
  response: NewDocument_CreateWuploadMutationResponse,
|};
*/


/*
mutation NewDocument_CreateWuploadMutation(
  $input: CreateWuploadInput!
) {
  createWupload(input: $input) {
    workspace {
      wuploads {
        edges {
          node {
            id
            mimetype
            name
            url
          }
        }
      }
      id
    }
    new_wupload_edge {
      node {
        id
        mimetype
        name
        url
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateWuploadInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateWuploadInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "node",
    "storageKey": null,
    "args": null,
    "concreteType": "Wupload",
    "plural": false,
    "selections": [
      v2,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "mimetype",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      }
    ]
  }
],
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "wuploads",
  "storageKey": null,
  "args": null,
  "concreteType": "WuploadConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "WuploadEdge",
      "plural": true,
      "selections": v3
    }
  ]
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "new_wupload_edge",
  "storageKey": null,
  "args": null,
  "concreteType": "WuploadEdge",
  "plural": false,
  "selections": v3
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "NewDocument_CreateWuploadMutation",
  "id": null,
  "text": "mutation NewDocument_CreateWuploadMutation(\n  $input: CreateWuploadInput!\n) {\n  createWupload(input: $input) {\n    workspace {\n      wuploads {\n        edges {\n          node {\n            id\n            mimetype\n            name\n            url\n          }\n        }\n      }\n      id\n    }\n    new_wupload_edge {\n      node {\n        id\n        mimetype\n        name\n        url\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "NewDocument_CreateWuploadMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createWupload",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateWuploadPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspace",
            "storageKey": null,
            "args": null,
            "concreteType": "Workspace",
            "plural": false,
            "selections": [
              v4
            ]
          },
          v5
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "NewDocument_CreateWuploadMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createWupload",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateWuploadPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "workspace",
            "storageKey": null,
            "args": null,
            "concreteType": "Workspace",
            "plural": false,
            "selections": [
              v4,
              v2
            ]
          },
          v5
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'caee2b16835050db71f2774d0c748167';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/__generated__/NewDocument_CreateWuploadMutation.graphql.js